import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';
export function registerItemsToSynchronizeListResourceBundleDe(i18next: i18n): void {
  i18next.addResourceBundle('de', 'record-it-components', {
    synchronization: {
      ItemsToSynchronizeList: {
        allItemsSynchronized: 'Alles synchronisiert!',
        waitingForSynchronization: 'Synchronisierung wartend: {{ count }}'
      }
    }
  } as Partial<CustomTypeOptions['resources']['record-it-components']>, true);
}